import type { FieldValues, Path, UseFormSetError } from "react-hook-form";

/** A backend `userErrors` entry, as a form draws it: the field it names, if any. */
export type FieldError = {
  field: string | null;
  message: string;
};

export const toFieldErrors = (
  userErrors: { field: string[]; message: string }[],
): FieldError[] =>
  userErrors.map((error) => ({
    field: error.field[0] ?? null,
    message: error.message,
  }));

export const failure = (message: string): FieldError[] => [
  { field: null, message },
];

/**
 * Shows each error that names a field in `fieldMap` (the backend's name -> the form's)
 * under its input; returns the message of the last one left over, for the form to show.
 */
export const applyFieldErrors = <Values extends FieldValues>(
  setError: UseFormSetError<Values>,
  errors: FieldError[],
  fieldMap: Record<string, Path<Values>>,
): string | null => {
  let unmatched: string | null = null;
  for (const { field, message } of errors) {
    if (field !== null && Object.hasOwn(fieldMap, field)) {
      setError(fieldMap[field], { type: "server", message });
    } else {
      unmatched = message;
    }
  }
  return unmatched;
};
